module.exports = __webpack_public_path__ + "img/about-bg.2752fe3.png";